import React from 'react'

import {
  FieldSpec,
  PaginatedTable,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  sku: { id: 'sku', label: 'SKU', ordering: 'sku', renderer: RelatedLinkedField(ValueField, 'sku') },
  product: { id: 'product', label: 'Product', ordering: 'sku__product__name', renderer: RelatedLinkedField(ValueField, 'name') },
  numAvailable: {
    id: 'numAvailable',
    label: 'Number of Units Available',
    ordering: 'num_available',
    renderer: ValueField,
  },
  numReserved: {
    id: 'numReserved',
    label: 'Number of Units in Orders',
    ordering: 'num_reserved',
    renderer: ValueField,
  },
  numAwaitingShipment: {
    id: 'numAwaitingShipment',
    label: 'Number of Units Awaiting Shipment',
    ordering: 'num_awaiting_shipment',
    renderer: ValueField,
  },
}

export const BatchSkuListTable = (props: ListTableProps) => {
  const { paginator, fields } = props

  return (
    <>
      <PaginatedTable
        title={props.title || "SKUs"}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
      />
    </>
  )
}
